import { useState, createContext } from 'react'
import { ModalContextType } from '../types/andTypes'

export const ModalContext = createContext({} as ModalContextType)

type ModalProviderProps = {
  children: JSX.Element
}

export const ModalProvider = ({ children }: ModalProviderProps) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [modalContent, setModalContent] = useState<JSX.Element>(<></>)
  const [previousContent, setPreviousContent] = useState<JSX.Element>(<></>)
  return (
    <ModalContext.Provider
      value={{
        modalOpen,
        setModalOpen,
        modalContent,
        setModalContent,
        previousContent,
        setPreviousContent
      }}
    >
      {children}
    </ModalContext.Provider>
  )
}
